import { api } from 'pages/APIs';
import AbstractApiService from 'src/services/abstractApiService';
import type { dynamicObj } from 'src/pages/assets';

export default class AsnApiService extends AbstractApiService {
  public constructor({}) {
    super({});
  }

  public async getAsnDashboard(data: dynamicObj): Promise<any> {
    const querystring = this.encodeQueryData(data);
    return super.get(
      api.get_master_data_lookup_asn_dashboard + '?' + querystring,
    );
  }
  public async getAsnDashboardOrderDetail(data: number): Promise<any> {
    return super.get(api.get_master_data_lookup_asn_dashboard_detail + data);
  }
  public async exportPdf(
    id: string,
    sales_order_line_id: string,
  ): Promise<any> {
    return super.get(
      api.get_master_data_lookup_asn_dashboard_export +
        id +
        '/' +
        sales_order_line_id,
    );
  }

  public async getAsnOrderPreview(data: number): Promise<any> {
    return super.get(api.get_asn_order_preview + data);
  }
  public async getAsnShareTokenService(id: any): Promise<any> {
    return super.get(
      api.get_master_data_lookup_asn_dashboard_detail + id + '/share',
      {},
    );
  }
}
